export default __webpack_public_path__ + "static/media/sen.2ae5088c.svg";